import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect } from 'react';
import "./Tableform.css";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { connect } from 'react-redux';
import ReactToPrint from "react-to-print";
import image from "../../../../../images/lifescience1.png";
import {
    getProjects
} from '../../../store/actions';

import { useRef } from 'react';
import { useParams } from "react-router-dom";
const useStyles = makeStyles({
    table: {
        height: "40px"
    },
    left: {
        margin: 600,
        width: "50%"
    },
    fontsize13: {
        fontSize: "13px",
    },
    rightContentHeader: {
        width: "88%",
        float: "left",
        textAlign: "left",
        paddingRight: "20px",
    },
    style: {
        background: "#AD70A6",
        color: "#fff",
        padding: 10,
        marginLeft: 5,
    }

});
interface Props {
    projects: any;
    getProjects: any;

}
const PhleboAdminViewBooking: React.FC<Props> = ({
    projects,
    getProjects,


}) => {
    const classes = useStyles();
    const contentArea = useRef<any>(0)
    const componentRef = useRef<any>(null);
    const { id } = useParams<{ id: string }>();
    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    }));
    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);
    const reactToPrintTrigger = React.useCallback(() => {
        return <button style={{ marginLeft: "10px", backgroundColor: "rebeccapurple", color: "white" }}>Print/Download</button>;
    }, []);

    useEffect(() => {
        getProjects(id);

    }, [])
    return (
        <>
            <div>
                <div style={{ height: "40px", marginTop: "35%", width: "250%" }}>
                    <h2></h2>
                    <div className={classes.rightContentHeader}>

                        <ReactToPrint
                            content={reactToPrintContent}
                            trigger={reactToPrintTrigger}
                        />
                    </div>
                </div>
            </div>
            <div
                style={{
                    width: 1122,
                    background: "#f1f1f1",
                    margin: "20px auto",
                    padding: 20
                }}
            >
                <div ref={componentRef} >
                    <div style={{ width: "100%", display: "flex", background: "#144272", marginTop: "30px" }}>
                        <div style={{ width: "100%", textAlign: "left", padding: 15 }}>
                            <h3><img src={image} alt="logo" style={{ width: "180px", color: "white" }} /></h3>
                            <div style={{ color: "white", fontWeight: "bold", textAlign: "center" }}><h3>Project Completion Form</h3></div>
                        </div>
                    </div>
                    <Box sx={{ flexGrow: 1 }} style={{ marginTop: "2%" }}>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                Project Id:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} value={projects?.projectId} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                Client Details:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} value={projects?.scientist?.name} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                Project Closer Date:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} value={projects?.deliverable?.createdAt ? projects?.deliverable?.closerFormSent?.split("T")[0] : ''} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                No of Sample(s) QC:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} value={projects?.sample?.receivedCount} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                Deliverables:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} value={projects?.phase} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                Email:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} value={projects?.scientist?.email} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                Library QC Report sent:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} value={projects?.libraryQcReport !== "" ? "Yes" : "No"} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                Raw Data Submitted to Client:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} value={projects?.bioInformatics?.rawDataShared === true ? "Yes" : "No"} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                Supplementary files sent:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} value={projects?.deliverable?.supplementaryFileSent === true ? "Yes" : "No"} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                Final Report Sent:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} value={projects?.deliverable?.finalReportSent === true ? "Yes" : "No"} />
                                        </Grid>
                                    </div>
                                </Grid>
                                {/* <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                Additional Analysis Report&files sent:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} />
                                        </Grid>
                                    </div>
                                </Grid> */}
                            </Grid>
                            {/* rest half page---------------------------> */}
                            <Grid item xs={6}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                Project Type:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} value={projects?.sample?.type} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                Sample Received date:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} value={projects?.sample?.createdAt ? projects?.sample?.createdAt?.split("T")[0] : ''} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                Samples as per Proposal:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} value={projects?.sample?.poCount} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                No: of Sample(s) Sequenced:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} value={projects?.librariesCount} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                Phone No.:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} value={projects?.scientist?.mobile} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                Sample QC Report sent:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} value={projects?.sampleQcReport !== "" ? "Yes" : "No"} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                Data QC Report sent:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} value={projects?.bioInformatics?.finalDataQcFile !== "" ? "Yes" : "No"} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                Raw data fulfilled:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} value={projects?.dataFulfilled === true ? "Yes" : "No"} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                Raw data sharing mode:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} value={projects?.bioInformatics?.rawDataSharingMode} />
                                        </Grid>
                                    </div>
                                </Grid>
                                {/* <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                Library kit used:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} />
                                        </Grid>
                                    </div>
                                </Grid> */}
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={6}>
                                            <div style={{ background: "#144272", padding: 10, color: "white" }}>
                                                BioInformatics Analysis Report:
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <input style={{ width: "100%", marginLeft: 5, padding: 8 }} value={projects?.bioInformatics?.analysisStatus} />
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                    <div style={{ width: "100%", display: "flex", margin: "8px 5px", marginTop: "20px" }}>
                        <h4 style={{
                            display: "inline", textAlign: "center"
                        }}>
                            Declaration by Redcliffe Lifesciences :
                        </h4>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 4px" }}>
                        <p style={{ display: "inline" }}>
                            We hereby declare that the above-mentioned NGS Project has been completed and all
                            the deliverables are met as per the accepted proposal.
                        </p>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                        <h4 style={{
                            display: "inline",
                        }}>
                            Confirmation by client:
                        </h4>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 4px" }}>
                        <p style={{ display: "inline" }}>
                            I/We agree about the results and Raw data submitted against the above-mentioned details of the said Project SO… for NGS work and accept the closure report.
                        </p>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 4px" }}>
                        <p style={{ display: "inline" }}>
                            Signature
                        </p>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 4px" }}>
                        <p style={{ display: "inline" }}>
                            Date :
                        </p>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 4px" }}>
                        <p style={{ display: "inline" }}>
                            Name :
                        </p>
                    </div>
                    <footer
                        className="div"
                        style={{
                            background: "#144272",
                            textAlign: "center",
                            padding: "20px",
                            border: "2px solid black",
                            color: "white"
                        }}
                    >
                        <p>
                            <h5 style={{ fontWeight: "bold" }}>Redcliffe Lifesciences Pvt. Ltd.</h5>
                        </p>
                        <p>
                            <p style={{ display: "inline" }}>
                                Building no: H-55, 3rd floor, Sector -63, Electronic City Center, Noida (UP)-201301.
                            </p>
                        </p>
                        <p>
                            Phone: +91-931-183-3761 | &nbsp; Email: projectsupport@redcliffelabs.com |
                            &nbsp; Website: www.redcliffelabs.com
                        </p>
                    </footer>
                </div>
            </div>
        </>
    );
}
const mapStateToProps = (state: any) => ({
    projects: state.GenomicsLabReducer.projects,
})

export default connect(mapStateToProps, {
    getProjects,
})(PhleboAdminViewBooking);